import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/machines/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/access-tokens',
      params: { organizationName: params.organizationName },
      search: { tab: 'machines' },
    });
  },
});
